"use client"

import * as React from "react"
import { ThemeProvider as NextThemesProvider } from "next-themes"
import { TRPCReactProvider } from "@/trpc/react"
import { NuqsAdapter } from "nuqs/adapters/next/app"
import { Analytics } from "@/components/analytics"

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <Analytics>
      <TRPCReactProvider>
        <NuqsAdapter>
          <NextThemesProvider
            attribute="class"
            defaultTheme="light"
            enableSystem
            disableTransitionOnChange
            enableColorScheme
          >
            {children}
          </NextThemesProvider>
        </NuqsAdapter>
      </TRPCReactProvider>
    </Analytics>
  )
}
